export const detectionEventName = "CookieBannerDetected";
export const detectionMessage = "cookie-banner.detected";
